import { ApiProperty } from "@nestjs/swagger";
export class ContainerYearRequest {
    @ApiProperty()
    year:number;    
}